import { FC, useEffect, useState, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Button,
  Modal,
} from "antd";

import { MailOutlined } from "@ant-design/icons";

// @ts-ignore
import { inviteOwner, getProjectUsers } from "modules/actions/UserActions";
import Notify from "utils/notify";


interface IInviteUserModal {
  isActive: boolean;
  emailToInvite: string;
  onClose: () => void;
  onUserInvitedAndAdded?: (newUserId: number) => void;
}

const InviteUserModal: FC<IInviteUserModal> = ({ isActive, emailToInvite, onClose, onUserInvitedAndAdded,}) => {
  const dispatch = useDispatch();
  const users = useSelector((state: any) => state.user.projectOwners?.users || []);
  const invitedUser = useSelector((state: any) => state.user.invitedUser || {});

  const [isLoading, setIsLoading] = useState(false);
  const [pendingEmail, setPendingEmail] = useState<string | null>(null);
  const lastErrorRef = useRef<string | null>(null);

  const handleInvite = () => {
    setIsLoading(true)
    lastErrorRef.current = null;
    setPendingEmail(emailToInvite);
    const payload = { invited_owner: emailToInvite };
    dispatch(inviteOwner(payload, (res?: any) => {
        const returnedId = res?.id || res?.user?.id;

        if (returnedId) {
          onUserInvitedAndAdded?.(returnedId);
          lastErrorRef.current = null;
          return handleOwnerModal();
        }

        dispatch(getProjectUsers());
      })
    );
  };

  const handleOwnerModal = useCallback(() => {
    setPendingEmail(null);
    setIsLoading(false);
    onClose();
 }, [onClose]);

  useEffect(() => {
    if (!pendingEmail) return;

    const found = users.find((u: any) =>
      (u?.email || "").trim().toLowerCase() === pendingEmail.trim().toLowerCase()
    );

    if (found?.id) {
      onUserInvitedAndAdded?.(found.id);
      handleOwnerModal();
    }
  }, [users, pendingEmail, onUserInvitedAndAdded, handleOwnerModal]);
  useEffect(() => {
    if (!invitedUser?.error) return;

    setIsLoading(false);
    setPendingEmail(null);

    const message =
      typeof invitedUser.error === "string"
        ? invitedUser.error
        : invitedUser.error?.message || "Failed to invite user";

    if (message && lastErrorRef.current !== message) {
      lastErrorRef.current = message;
      Notify.error(message, false);
    }
  }, [invitedUser?.error]);

  return (
    <Modal
      footer={null}
      onCancel={onClose}
      title={false}
      open={isActive}
    >
      <div className="font-18 mb-1">Share this action</div>

      <div>
        {/* Sharing <b className='underline'>{record?.name}</b> action */}
      </div>

      <div className="ownerModalEmail">
        <div className="ownerEmailDiv">{emailToInvite}</div>
      </div>

      <Button
        icon={<MailOutlined />}
        className="inviteButton"
        type="primary"
        loading={isLoading}
        // disabled={!inviteEmail}
        onClick={handleInvite}
      >
        Invite
      </Button>
    </Modal>
  );
};

export default InviteUserModal;
